export const EEContactInfo = {
  InfoEmail: "info@energyengg.com",
};
